export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Dj Oko Mensah',
      rating: 5,
      text: 'Works fast and uses better materials for the job.. highly recommends them'
    },
    {
      name: 'Joe Dreckman',
      rating: 5,
      text: 'We are very happy with our new deck. During construction all concerns were addressed promptly. The attention to detail is awsome and the price very competitive.'
    },
    {
      name: 'Michael Gibson',
      rating: 5,
      text: '… good humble guys. Highly highly highly skilled craftsmen. I for sure cried when they were finished. It was beyond good work, they\'re worth every dollar they charge.'
    },
    {
      name: 'Z',
      rating: 5,
      text: 'I\'m so glad we used Dra\'s Deck and Remodel for our deck restoration. Our deck was still structurally sound but needed a major overhaul to make it useable and safe. Ted and his crew were wonderful. Ted made some great suggestions, and I fully trusted his judgment about how to fix some unforeseen issues that came up along the way. They took their time and made sure that everything was done well and to our satisfaction. James was helpful and responsive and also made sure we were happy with the job. Great work done by kind people. We will be using Dra\'s for any future renovation work we need done and I\'d recommend them to anyone.'
    },
    {
      name: 'Michelle',
      rating: 5,
      text: 'I asked for a gate to be put up to keep our dog in the back yard. James was able to put up next day. He gave me a fair price and now we have a great gate! Thanks for the quality work!'
    },
    {
      name: 'Sean',
      rating: 5,
      text: 'James always comes thru with an excellent product. And if anything is ever an issue he immediately comes to fix it. Including at 11PM on more than one occasion. I would highly recommend his services.'
    },
    {
      name: 'Aisha',
      rating: 5,
      text: 'James did an excellent job building picnic tables for me on short notice. He made them exactly how I envisioned — with foldable legs, making them easy to transport. My family and friends will definitely get great use out of them. I truly appreciate his craftsmanship and attention to detail.'
    },
    {
      name: 'Anonymous Customer',
      rating: 5,
      text: 'Our home had a lot of "surprises", but they were beautifully repaired. James saved, restored, our wooden windows, designed a unique Juliet deck, as well as remedied other issues where the wood had rotted and literally disintegrated. When problems arose, James was here to make sure things were perfectly repaired. It was a huge undertaking. When we can, we will ask his assistance with additional renovations.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            What Our <strong>Clients Say</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied clients have to say about working with DDR Construction Solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="mb-6">
                <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>

              <p className="text-gray-600 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
